var render, staticRenderFns
import script from "./TrainContainer.vue?vue&type=script&lang=js"
export * from "./TrainContainer.vue?vue&type=script&lang=js"
import style0 from "./TrainContainer.vue?vue&type=style&index=0&id=652dcfea&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports